/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Franchise_Create_Child_ModelInputs */

const cs_franchise_create_child_model = /** @type {(inputs: Franchise_Create_Child_ModelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ kanceláře`)
};

const en_franchise_create_child_model = /** @type {(inputs: Franchise_Create_Child_ModelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Office type`)
};

/**
* | output |
* | --- |
* | "Office type" |
*
* @param {Franchise_Create_Child_ModelInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const franchise_create_child_model = /** @type {((inputs?: Franchise_Create_Child_ModelInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Franchise_Create_Child_ModelInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_franchise_create_child_model(inputs)
	return cs_franchise_create_child_model(inputs)
});